<template>
  <div>
    <b-field grouped>
      <b-field
        label="車台番号"
        expanded
        :type="listErrType.errVinNo"
        :message="listMsgValidation.msgVinNo"
      >
        <b-input
          v-model="item.vinNo"
          @input="checkUpdateVinNo"
          :loading="isWaitUpdate"
        ></b-input>
      </b-field>
      <b-field v-if="item.matterNo != ''">
        <b-button 
        class="btn-request-update" @click="requestUpdateVinNo" 
          >他システム更新</b-button
        >
      </b-field>
      <b-field class="radio-checkbox">
        <b-radio
          name="plate"
          v-model="item.hasNumberPlate"
          :native-value="true"
          :disabled="isBookedItem"
          @input="updateHasNumberPlate"
        >
          ナンバー有り
        </b-radio>
        <b-radio
          name="plate"
          v-model="item.hasNumberPlate"
          :native-value="false"
          :disabled="isBookedItem"
          @input="updateHasNumberPlate"
        >
          ナンバー無し
        </b-radio>
      </b-field>
    </b-field>
    <b-field grouped>
      <b-field label="モデル" expanded>
        <b-input v-model="item.model" :disabled="isBookedItem"></b-input>
      </b-field>
      <b-field label="グレード" expanded>
        <b-input v-model="item.grade" :disabled="isBookedItem"></b-input>
      </b-field>
      <b-field
        label="年式（西暦）"
        expanded
        :type="listErrType.errYear"
        :message="listMsgValidation.msgYear"
      >
        <b-input
          v-model="item.year"
          @input="validationInput"
          :disabled="isBookedItem"
        >
        </b-input>
      </b-field>
    </b-field>
    <b-field grouped>
      <b-field label="走行距離" expanded>
        <b-input v-model.number="item.mileage" :disabled="isBookedItem">
        </b-input>
      </b-field>
      <b-field label="色" expanded>
        <b-input v-model="item.color" :disabled="isBookedItem"> </b-input>
      </b-field>
      <b-field label="スコア" expanded>
        <b-input v-model="item.score" :disabled="isBookedItem"> </b-input>
      </b-field>
    </b-field>
  </div>
</template>
<style>
.radio-checkbox {
  padding-top: 10px;
}
.btn-request-update {
  color: #fff;
  background-color: #2d70d3;
  border-radius: 10px;
}
</style>
<script>
const regexFormatNumber = /^[0-9]+$/;
import jcPackage from '@/repositories/jcPackage';
export default {
  props: ['item', 'previosVinNo', 'isBookedItem'],
  data: () => ({
    listMsgValidation: {
      msgVinNo: '',
      msgYear: '',
    },
    listErrType: {
      errVinNo: '',
      errYear: '',
    },
    isWaitUpdate: false,
  }),
  methods: {
    updateHasNumberPlate() {
      if (!this.item.hasNumberPlate) {
        this.item.transportOptionNumberPlateCut = false;
      }
    },
    checkUpdateVinNo(val) {
      if (
        val === this.previosVinNo || this.item.matterNo === ''
      ) {
        this.listErrType.errVinNo = '';
        this.listMsgValidation.msgVinNo = '';
      } else {
        this.listErrType.errVinNo = 'is-danger';
        this.listMsgValidation.msgVinNo =
          '車台番号が変わっています。「他システム更新」ボタンをクリックして他システムの更新を行ってください。';
      }
      this.$emit('responeValidateItemVehical', this.listMsgValidation);
    },
    requestUpdateVinNo(p) {
      if (this.item.vinNo === this.previosVinNo) {
        return;
      }
      this.isWaitUpdate = true;
      const data = {
        matter_no: this.item.matterNo,
        vin_no: this.item.vinNo,
      };
      jcPackage
        .requestUpdateTransport(this.$store.state.accessTokenJPC, data)
        .then((rs) => {
          this.listErrType.errVinNo = '';
          this.listMsgValidation.msgVinNo = '';
          this.isWaitUpdate = false;
          this.updateVinNoInFirebase(data);
          this.$emit('responeUpdateSuccess');
        })
        .catch((err) => {
          this.listErrType.errVinNo = 'is-danger';
          this.listMsgValidation.msgVinNo =
            '他システムに更新できませんでした。再度実施してください。';
          this.isWaitUpdate = false;
        });
    },
    validationInput() {
      if (
        regexFormatNumber.test(this.item.year) &&
        this.item.year.length <= 4
      ) {
        this.listErrType.errYear = '';
        this.listMsgValidation.msgYear = '';
      } else {
        this.listErrType.errYear = 'is-danger';
        this.listMsgValidation.msgYear =
          '入力フォーマットに誤りがあります。yyyy形式で入力してください。';
      }
      this.$emit('responeValidateItemVehical', this.listMsgValidation);
    },
    updateVinNoInFirebase(data) {
      this.$store.dispatch('updateVinNoInFireBase', data);
    },
  },
};
</script>
